//应力深孔数值
const STRESS_DEEP_VALUE_L1 = '96304485550403584';
const STRESS_DEEP_VALUE_L2 = '96304485642678272';
const STRESS_DEEP_VALUE_L3 = '96304485747535872';

//应力深孔变化率
const STRESS_DEEP_RATE_VALUE_L1 = "96304486116634624";
const STRESS_DEEP_RATE_VALUE_L2 = "96304486200520704";
const STRESS_DEEP_RATE_VALUE_L3 = "96304486305378304";

//应力浅孔数值
const STRESS_SHALLOW_VALUE_L1 = '96304485252608000';
const STRESS_SHALLOW_VALUE_L2 = '96304485378437120';
const STRESS_SHALLOW_VALUE_L3 = '96304485466517504';

//应力浅孔变化率
const STRESS_SHALLOW_RATE_VALUE_L1 = "96304485839810560";
const STRESS_SHALLOW_RATE_VALUE_L2 = "96304485919502336";
const STRESS_SHALLOW_RATE_VALUE_L3 = "96304486020165632";

//煤矿级别微震能量等级参数
const WZ_COLLIERY_LEVEL_WEAK = "96304486527676416";//弱
const WZ_COLLIERY_LEVEL_MEDIUM = "96304486649311232";//中
const WZ_COLLIERY_LEVEL_STRONG = "96304486737391616";//强

//钻屑出粉量米数检测标准
const HOLE_CUTTING_NUMBER_L1 = "96304489845370880";
const HOLE_CUTTING_NUMBER_L2 = "96304489920868352";
const HOLE_CUTTING_NUMBER_L3 = "96304490004754432";
const HOLE_CUTTING_NUMBER_L4 = "96304490147360768";
const HOLE_CUTTING_NUMBER_L5 = "96304490541625344";
const HOLE_CUTTING_NUMBER_L6 = "96304490705203200";
const HOLE_CUTTING_NUMBER_L7 = "96304490839420928";
const HOLE_CUTTING_NUMBER_L8 = "96304490914918400";
const HOLE_CUTTING_NUMBER_L9 = "96304491002998784";
const HOLE_CUTTING_NUMBER_L10 = "96304491091079168";
const HOLE_CUTTING_NUMBER_L11 = "96304491179159552";
const HOLE_CUTTING_NUMBER_L12 = "96304491263045632";
const HOLE_CUTTING_NUMBER_L13 = "96304491359514624";
const HOLE_CUTTING_NUMBER_L14 = "96304491439206400";
const HOLE_CUTTING_NUMBER_L15 = "96304491535675392";
const HOLE_CUTTING_NUMBER_L16 = "96304491611172864";
const HOLE_CUTTING_NUMBER_L17 = "96304491711836160";
const HOLE_CUTTING_NUMBER_L18 = "96304491816693760";
const HOLE_CUTTING_NUMBER_L19 = "96304491896385536";
const HOLE_CUTTING_NUMBER_L20 = "96304492026408960";

//地音传感器位置
const EARTH_SOUND_DISTANCE_1 = "96304493364391937";
const EARTH_SOUND_DISTANCE_2 = "96304493364391938";
const EARTH_SOUND_DISTANCE_3 = "96304493364391939";
const EARTH_SOUND_DISTANCE_4 = "167635872399896581";
const EARTH_SOUND_DISTANCE_5 = "167635872399896582";
const EARTH_SOUND_DISTANCE_6 = "167635872399896583";
const EARTH_SOUND_DISTANCE_7 = "436478256569524224";
const EARTH_SOUND_DISTANCE_8 = "436478256569524225";
const EARTH_SOUND_DISTANCE_9 = "436478256569524226";
const EARTH_SOUND_DISTANCE_10 = "436478256569524227";

//支架阻力
const RESISTANCE_WEAK = "167635872399896576";//弱
const RESISTANCE_MEDIUM = "167635872399896577";//中
const RESISTANCE_STRONG = "167635872399896578";//强

const UPDATE_QUAKE_X_NUMBER = "96304489589518336";//修正X数轴坐标
const UPDATE_QUAKE_Y_NUMBER = "96304489685987328";//修正Y数轴坐标
const FOOTTAGE_INTERVAL_VALUE = '96304493242757120';
const WZ_SEARCH_DAYS = "96304489765679104";//微震查询天数
const AMPLITUDE_ATTENUATION_COEFFICIENT = "96304487718858752";//振幅衰减系数
const WARNING_THRESHOLD = "96304487802744832";//预警临界值
const EARLY_WARNING_SAFETY_FACTOR = "96304487349760000";//预警安全系数
const TUNNEL_WIDTH = '96304492101906432';//巷道宽度
const COAL_SEAM_THICKNESS = "96304487177793536";//煤层厚度
const TUNNEL_HEIGHT = "96304487098101760";//巷高
const WEIGHT_SUIT = "167635872399896584";//权重适应
const STRESS_INITIAL = "96304484917063680";//应力初值

const FOOTAGE_WATER_INFLOW = "1";//进尺配置项 涌水量
const COMPREHENSIVE_STRESS = "190475883125932032"; //应力显示模式

const INDEX_RUO_LEVEL = "96304486829666304";//指标范围弱
const INDEX_ZHONG_LEVEL = "96304486930329600";//指标范围中
const INDEX_QIANG_LEVEL = "96304487018409984";

const INDEX_STRESS_ID = "96304487895019521";//指标应力UID
const BACKGROUND_QUAKE_DAY = "96304487437840388";//微震/微震指标背景天数
const MODEL_INDEX_SCALEfACTOR = "167635872399896585";

const CT_RISK_NORMAL_WEAK = "210073942545801216";//ct弱
const CT_RISK_NORMAL_SECONDARY = "210073942545801217";//CT中
const CT_RISK_NORMAL_STRONG = "210073942545801218";//ct强

const CT_RISK_UNNORMAL_WEAK = "210073942545801219";//CT反演/风险等级/弱化
const CT_RISK_UNNORMAL_SECONDARY = "210073942545801220";//CT反演/风险等级/中等弱化
const CT_RISK_UNNORMAL_STRONG = "210073942545801221";//CT反演/风险等级/强弱化

const STRAINENERGY_WEAK = "225898378905710601";//冲击弱
const STRAINENERGY_SECONDARY = "225898378905710602"; // 冲击中
const STRAINENERGY_STRONG = "225898378905710603"; // 冲击强

const INTELLECTdISTINGUISH_WEAK = "225898378905710611";//智能判识弱
const INTELLECTdISTINGUISH_SECONDARY = "225898378905710612";//智能判识中
const INTELLECTdISTINGUISH_STRONG  = "225898378905710613";//智能判识强

const EARTHSOUND_CLASS_ONE = "96304492433256448";
const EARTHSOUND_CLASS_TWO = "96304492525531136";
const EARTHSOUND_CLASS_THREE = "96304492609417216";
const EARTHSOUND_CLASS_FOUR = "96304492693303296";
const EMPTY_COAL_AREA_SHOW = "244094751417233408";

const NEW_SCREEN_PAGE = "244410166957768708";

const FORECAST_DAYS = '317245607150497792'; //通用/综合指标预测天数
const PREDICTION_TIME_WINDOE = '317245607150497793'; //通用/综合指标预测时间窗
const EARTH_SOUND_INTERAL_METRE = '418790426368155648';//地音位置/间隔米数

const MAP_SHOW_STYLE = '436478256569524228';// 矿图/展示方式
const ROOT_WARN_SHALLOW_LINE = '436478256569524234'; //顶板离层预浅基点累计下沉预警值
const ROOT_WARN_SHALLOW_CRITICAL_LINE = '436478256569524236'; //顶板离层/浅基点累计下沉临界值
const ROOT_WARN_DEEP_LINE = '436478256569524237';// 顶板离层/深基点累计下沉预警值
const ROOT_WARN_DEEP_CRITICAL_LINE = '436478256569524238';// 顶板离层/深基点累计下沉临界值
const ROOT_WARN_STYLE = '436478256569524239';// 顶板离层/采集方式
const BOLT_WARN_LINE = '436478256569524235'; // 锚杆锚索预警线
const ANCHAOR_WARN_STYLE = '436478256569524240'; // 锚杆锚索/采集方式
const EFFECTIVE_DATE = '436478256569524241';//有效天数
const RESISTANCE_KN = '436478256569524242';//通用>回采截距
const ADVANCE_DISPLAY_MODE = '436478256569524244';// 通用 > 显示推进度

export default{
    ADVANCE_DISPLAY_MODE,
    RESISTANCE_KN,
    EFFECTIVE_DATE,
    ANCHAOR_WARN_STYLE,
    BOLT_WARN_LINE,
    ROOT_WARN_SHALLOW_LINE,
    ROOT_WARN_SHALLOW_CRITICAL_LINE,
    ROOT_WARN_DEEP_LINE,
    ROOT_WARN_DEEP_CRITICAL_LINE,
    ROOT_WARN_STYLE,

    EARTH_SOUND_INTERAL_METRE,
    EARTHSOUND_CLASS_ONE,
    EARTHSOUND_CLASS_TWO,
    EARTHSOUND_CLASS_THREE,
    EARTHSOUND_CLASS_FOUR,

    MAP_SHOW_STYLE,

    INTELLECTdISTINGUISH_WEAK,
    INTELLECTdISTINGUISH_SECONDARY,
    INTELLECTdISTINGUISH_STRONG,

    STRAINENERGY_WEAK,
    STRAINENERGY_SECONDARY,
    STRAINENERGY_STRONG,

    CT_RISK_UNNORMAL_WEAK,
    CT_RISK_UNNORMAL_SECONDARY,
    CT_RISK_UNNORMAL_STRONG,

    CT_RISK_NORMAL_WEAK,
    CT_RISK_NORMAL_SECONDARY,
    CT_RISK_NORMAL_STRONG,

    RESISTANCE_WEAK,
    RESISTANCE_MEDIUM,
    RESISTANCE_STRONG,

    UPDATE_QUAKE_X_NUMBER,
    UPDATE_QUAKE_Y_NUMBER,

    TUNNEL_WIDTH,
    COAL_SEAM_THICKNESS,
    TUNNEL_HEIGHT,

    EARTH_SOUND_DISTANCE_1,
    EARTH_SOUND_DISTANCE_2,
    EARTH_SOUND_DISTANCE_3,
    EARTH_SOUND_DISTANCE_4,
    EARTH_SOUND_DISTANCE_5,
    EARTH_SOUND_DISTANCE_6,
    EARTH_SOUND_DISTANCE_7,
    EARTH_SOUND_DISTANCE_8,
    EARTH_SOUND_DISTANCE_9,
    EARTH_SOUND_DISTANCE_10,

    HOLE_CUTTING_NUMBER_L1 ,
    HOLE_CUTTING_NUMBER_L2 ,
    HOLE_CUTTING_NUMBER_L3 ,
    HOLE_CUTTING_NUMBER_L4 ,
    HOLE_CUTTING_NUMBER_L5 ,
    HOLE_CUTTING_NUMBER_L6 ,
    HOLE_CUTTING_NUMBER_L7 ,
    HOLE_CUTTING_NUMBER_L8 ,
    HOLE_CUTTING_NUMBER_L9 ,
    HOLE_CUTTING_NUMBER_L10,
    HOLE_CUTTING_NUMBER_L11,
    HOLE_CUTTING_NUMBER_L12,
    HOLE_CUTTING_NUMBER_L13,
    HOLE_CUTTING_NUMBER_L14,
    HOLE_CUTTING_NUMBER_L15,
    HOLE_CUTTING_NUMBER_L16,
    HOLE_CUTTING_NUMBER_L17,
    HOLE_CUTTING_NUMBER_L18,
    HOLE_CUTTING_NUMBER_L19,
    HOLE_CUTTING_NUMBER_L20,

    STRESS_DEEP_VALUE_L1,
    STRESS_DEEP_VALUE_L2,
    STRESS_DEEP_VALUE_L3,
    STRESS_DEEP_RATE_VALUE_L1,
    STRESS_DEEP_RATE_VALUE_L2,
    STRESS_DEEP_RATE_VALUE_L3,

    STRESS_SHALLOW_VALUE_L1,
    STRESS_SHALLOW_VALUE_L2,
    STRESS_SHALLOW_VALUE_L3,
    STRESS_SHALLOW_RATE_VALUE_L1,
    STRESS_SHALLOW_RATE_VALUE_L2,
    STRESS_SHALLOW_RATE_VALUE_L3,

    FOOTTAGE_INTERVAL_VALUE,

    WZ_COLLIERY_LEVEL_WEAK,
    WZ_COLLIERY_LEVEL_MEDIUM,
    WZ_COLLIERY_LEVEL_STRONG,
    WZ_SEARCH_DAYS,

    AMPLITUDE_ATTENUATION_COEFFICIENT,
    WARNING_THRESHOLD,
    EARLY_WARNING_SAFETY_FACTOR,
    WEIGHT_SUIT,
    STRESS_INITIAL,
    FOOTAGE_WATER_INFLOW,
    COMPREHENSIVE_STRESS,

    INDEX_RUO_LEVEL,
    INDEX_ZHONG_LEVEL,
    INDEX_QIANG_LEVEL,

    INDEX_STRESS_ID,
    BACKGROUND_QUAKE_DAY,
    MODEL_INDEX_SCALEfACTOR,
    EMPTY_COAL_AREA_SHOW,
    NEW_SCREEN_PAGE,


    FORECAST_DAYS,
    PREDICTION_TIME_WINDOE
}



// WEBPACK FOOTER //
// ./src/constants/profile.constants.js